module.exports = __webpack_public_path__ + "media/images/logo-5-d66f0da0520f30249d29d6403219e227.png";